import * as types from '../types'
import createReducer from 'shared/utils/createReducer'

export const initialState = {
  isFetching: false,
  lastFetched: undefined,
  data: undefined
}

const setFetchingLeadSchemeList = (state, { isFetching = true }) => ({ ...state, isFetching })
const setLeadSchemeList = (state, { data }) => ({
  ...state,
  isFetching: false,
  data,
  lastFetched: new Date()
})

export const actionList = {
  [types.LEAD_SET_FETCHING_LEAD_SCHEME_LIST]: setFetchingLeadSchemeList,
  [types.LEAD_SET_LEAD_SCHEME_LIST]: setLeadSchemeList,
}

export const reducer = createReducer(initialState, actionList)
export default reducer
